import classNames from 'classnames';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import { IMAGE_SOURCE } from 'src/utils/constants';
import styles from './Image.module.css';
export type TpImageProps = ImageProps & {
  containerClassName?: string;
  negativeXOffset?: boolean;
  aspectRatio?: string;
};
const customLoader = ({
  src
}: {
  src: string;
}) => `${IMAGE_SOURCE}${src}`;
export const CustomImage = (props: TpImageProps) => {
  const {
    src,
    containerClassName,
    negativeXOffset,
    aspectRatio,
    ...otherProps
  } = props;
  return <span className={classNames(styles.container, {
    [styles.negativeXOffset]: negativeXOffset
  }, containerClassName)} style={{
    aspectRatio
  }} data-sentry-component="CustomImage" data-sentry-source-file="index.tsx">
      <Image src={src} loader={customLoader} {...otherProps} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </span>;
};